jQuery(document).ready(function ($) {
	function toggleNav() {
		$(".nav-closed, .nav-button, .logo_img").toggleClass("open");

		$(".nav-button").hasClass("open") ? openNav() : closeNav();
	}

	function openNav() {
		scroll(document.getElementById("header"), -20, 0);

		$("html").css({
			overflowY: "hidden",
		});

		$(".blur").css({
			opacity: 1,
			pointerEvents: "all",
		});
	}

	function closeNav() {
		$("html").css({
			overflowY: "scroll",
		});

		$(".blur").css({
			opacity: 0,
			pointerEvents: "none",
		});
	}

	$(".blur").on("click", toggleNav);
	$("#nav-btn").on("click", toggleNav);

	/* Focus searchwp input when the nav button is open */
	$("#search-btn").on("click", () => {
		$(".nav-closed, .nav-button, .logo_img").toggleClass("open");
		$(".swp-input--search").focus();
	});

	const menu_dropdowns = document.querySelectorAll(".menu-item-has-children");

	menu_dropdowns.forEach((dropdown) => {
		$(dropdown).addClass("hide");

		$(dropdown).on("click", () => {
			$(dropdown).toggleClass("hide");
		});
	});

	//header spacing
	let headerHeight = $("#header").outerHeight();

	const pagesWithMorePadding = [
		"single-news",
		"single-investments",
		"page-id-3",
	];

	// check <body> for any classes in pagesWithMorePadding[]
	const pageHasAddedPadding = pagesWithMorePadding.some((pageClass) =>
		document.querySelector("body").classList.contains(pageClass)
	);

	if (pageHasAddedPadding) {
		headerHeight += 8; // add small amount of extra padding if pageHasAddedPadding = true
	}

	$(".header-spacing, .nav-spacing").css("padding-top", `${headerHeight}px`);

	// create the orange hover effect for the main nav links
	const menuItems = document.querySelectorAll("#menu-header_nav > .menu-item");
	menuItems.forEach((menuItem) => {
		const { innerText, href } = menuItem.querySelector("a");

		menuItem.innerHTML += `<a class="hover" href="${href}" tabindex="-1">${innerText}</a>`;
	});
});
